import { NgModule } from '@angular/core';
import { SharedModule } from '@ecip/shared';
import { ApplicationRoutingModule } from './application-routing.module';
import { ApplicationAppsComponent } from './apps/apps.component';
import { ApplicationAppsViewComponent } from './apps/view/view.component';
import { ApplicationAppsEditComponent } from './apps/edit/edit.component';

const COMPONENTS = [
  ApplicationAppsComponent];
const COMPONENTS_NOROUNT = [
  ApplicationAppsViewComponent,
  ApplicationAppsEditComponent];

@NgModule({
  imports: [
    SharedModule,
    ApplicationRoutingModule
  ],
  declarations: [
    ...COMPONENTS,
    ...COMPONENTS_NOROUNT,
  ],
  entryComponents: COMPONENTS_NOROUNT
})
export class ApplicationModule { }
